import styled, { css } from "styled-components";
import { colors, colorsHover } from "../../../styles/colors";

export const ModalContentWrapper = styled.div`
  padding: 1rem;

  header {
    font-weight: 600;
    text-align: center;
  }

  main {
    margin-top: 1rem;
  }
`;

export const StyledForm = styled.form<{ $isLoading?: boolean }>`
  ${({ $isLoading }) =>
        $isLoading &&
        css`
      select,
      input {
        background-color: ${colors.unabled} !important;
        cursor: not-allowed !important;

        &[type="checkbox"] + label {
          text-decoration: line-through;
          cursor: not-allowed !important;
        }
      }

      button {
        pointer-events: none !important;
        background-color: ${colors.unabled} !important;
      }

      button[type="submit"] {
        padding-right: 1.8rem;
        position: relative;

        &::after {
          content: "";
          background: url("../../../assets/loader/default.png") no-repeat center
            center / 20px 20px;
          width: 20px;
          height: 20px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0.2rem;
        }
      }
    `}

  button {
    font-size: 16px !important;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Field = styled.div<{ $hidden?: boolean }>`
  display: ${({ $hidden }) => ($hidden ? "none" : "block")};

  & > label {
    font-size: 14px;
    font-weight: 600;
  }

  & > input[type="checkbox"] {
    cursor: pointer;

    & + label {
      cursor: pointer;
      margin-left: 0.3rem;
      font-size: 14px;
    }
  }

  & > input:not([type="checkbox"]),
  & > select {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
    font-size: 14px;
    outline: none;
    padding: 0.3rem;
    transition: border-bottom 0.3s, background-color 0.3s;
    width: 100%;
    box-sizing: border-box;

    &[disabled] {
      background-color: #eee;
    }

    &:hover,
    &:focus {
      border-bottom: 1px solid rgba(0, 0, 0, 0.7);
    }
  }

  & > select {
    cursor: pointer;
  }
`;

export const ParamsSection = styled.div`
  .title {
    font-weight: 600;
  }
`;

export const ParamsList = styled.div`
  overflow: auto;
  max-height: 40vh;
`;

export const ParamItem = styled.div<{ $active?: boolean }>`
  border-radius: 2px;
  margin: 0.5rem 0.2rem;
  padding: 0.2rem 0.5rem;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: box-shadow 0.3s;
  position: relative;
  min-height: 30px;

  &::after {
    content: "";
    background: url("../../../assets/chevron-down-solid.svg") no-repeat center
      center / 12px 12px;
    width: 12px;
    height: 12px;
    position: absolute;
    right: 0.3rem;
    top: 0.5rem;
    transform: ${({ $active }) => ($active ? "rotate(0deg)" : "rotate(90deg)")};
    transition: transform 0.3s;
  }

  ${({ $active }) =>
        $active &&
        css`
      box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
    `}

  .title {
    font-style: italic;
    user-select: none;
  }

  .fields {
    max-height: ${({ $active }) => ($active ? "800px" : "0px")};
    height: fit-content;
    overflow: hidden;
    transition: max-height 0.5s;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .actions > button {
      width: 100%;
      background-color: ${colors.danger};
      border-radius: 2px;
      color: white;
      text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
      transition: background-color 0.3s;
      border: none;
      padding: 0.4rem;
      cursor: pointer;

      &:hover {
        background-color: ${colorsHover.danger};
      }
    }
  }
`;

export const FormActions = styled.div<{ $removeActive?: boolean }>`
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;

  ${({ $removeActive }) =>
        $removeActive
            ? css`
          justify-content: flex-start;
          .submit_button,
          .remove_button {
            display: none;
          }
        `
            : css`
          .confirm_button,
          .cancel_button {
            display: none;
          }
        `}

  button {
    color: white;
    padding: 0.1rem 0.6rem;
    border-radius: 2px;
    font-weight: 600;
    transition: background-color 0.3s;
    border: none;
    cursor: pointer;
    min-height: 30px;

    &.cancel_button,
    &.remove_button {
      background-color: ${colors.danger};
      &:hover {
        background-color: ${colorsHover.danger};
      }
    }

    &.confirm_button {
      background-color: ${colors.success};
      &:hover {
        background-color: ${colorsHover.success};
      }
    }

    &.submit_button {
      background-color: ${colors.primary};
      &:hover {
        background-color: ${colorsHover.primary};
      }
    }

    &.add_param_button {
      background-color: ${colors.unabledDark};
      width: 100%;
      margin: 0.5rem 0.2rem;
      &:hover {
        background-color: ${colors.unabled};
      }
    }
  }
`;
